import { ORDER_ITEM_STATUS } from 'server/constants/orderStatus';
import { IOrderItem } from 'server/models/OrderItem';
export const numberOfInstoreOrderItems = (items: IOrderItem[]) =>
  items.filter((el) => el.orderStatus === ORDER_ITEM_STATUS.ORDER_ITEM_IN_ASAP_STORE).length;
